import { createContext, useCallback, useContext, useEffect, useState } from "react";
import it from "./it";
import en from "./en";

// Add new languages here (e.g. de, fr) and they become selectable automatically.
export const LANGS = { it: { label: "IT", dict: it, locale: "it-IT" }, en: { label: "EN", dict: en, locale: "en-GB" } };

const I18nCtx = createContext(null);

const lookup = (dict, key) => key.split(".").reduce((o, k) => (o == null ? undefined : o[k]), dict);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("juppo_lang") || "it");
  useEffect(() => {
    localStorage.setItem("juppo_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((key) => {
    const v = lookup(LANGS[lang].dict, key);
    return v === undefined ? lookup(it, key) ?? key : v;
  }, [lang]);
  return <I18nCtx.Provider value={{ lang, setLang, t, locale: LANGS[lang].locale }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
